import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Header from 'supportAssistant/components/History/Header'
import ChatPreview from 'supportAssistant/components/History/ChatPreview'
import { mediaQueryUp } from 'components/utils/breakpoint'
import ChatPreviewLoadingSkeleton from './ChatPreviewLoadingSkeleton'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${rem(60)} auto;
  height: 100%;
  width: 100%;
  min-width: ${rem(232)};
  background-color: ${({ theme }) => theme.palette.neutral.default.eight};

  ${mediaQueryUp.desktop} {
    min-width: ${rem(310)};
  }
`

const ChatHistory = styled.div`
  overflow: auto;
  height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  &--scroll-container {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`

interface Props {
  activeChatId?: string;
  chatsHistory: any[];
  onSelectChat: (chatId: string) => void;
  onNewChat?: () => void;
  loadingChatsHistory?: boolean;
}

function ChatsHistory({
  activeChatId,
  chatsHistory,
  onSelectChat,
  onNewChat,
  loadingChatsHistory,
}: Props) {
  const modalState = useModalElementContext<string>()

  const handleNewChatClick = () => {
    onNewChat?.()
    modalState?.resolve?.('')
  }

  const handleSelectChatClick = (chatId: string) => {
    onSelectChat(chatId)
    modalState?.resolve?.('')
  }

  return (
    <Container>
      <Header onNewChatClick={handleNewChatClick} />
      <ChatHistory>
        {chatsHistory.length === 0 && !loadingChatsHistory && (
          <ChatPreview
            onClick={() => {}} title="New chat"
            chatCreatedAt={new Date().toString()}
            lastMessageAt={new Date().toString()}
            isActive
          />)
        }
        {loadingChatsHistory && (
          <ChatPreviewLoadingSkeleton />
        )}
        {!loadingChatsHistory && chatsHistory.map(chat => (
          <ChatPreview key={chat.id} onClick={() => handleSelectChatClick(chat.id)} title={chat.title}
                       chatCreatedAt={chat.createdAt} lastMessageAt={chat.lastMessageAt}
                       isActive={chat.id === activeChatId} agentType={chat.agentType}/>
        ))}
      </ChatHistory>
    </Container>
  )
}

export default ChatsHistory
